import { useMutation, useQueryClient } from '@tanstack/react-query';
import { strapiSaveUserPermissionPreset } from '../../api/strapiUsers';
import { queryKeys } from '../queryKeys';

export function useSaveUserPermissionPresetMutation(jwt: string | null) {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: ({
      userId,
      permissionAccessDocumentIds,
    }: {
      userId: string;
      permissionAccessDocumentIds: string[];
    }) => {
      if (!jwt) throw new Error('Not signed in');
      return strapiSaveUserPermissionPreset(jwt, userId, permissionAccessDocumentIds);
    },
    onSuccess: async (_, vars) => {
      await qc.invalidateQueries({ queryKey: [...queryKeys.strapi, 'users'] });
      await qc.invalidateQueries({ queryKey: queryKeys.userDetail(jwt, vars.userId) });
      await qc.invalidateQueries({ queryKey: queryKeys.navigationMenu(jwt) });
    },
  });
}
